import React from "react";

export default function EmptyTable({ message }) {
  return <div className="flex justify-center items-center h-40">{message}</div>;
}
